import { TbNotes } from "react-icons/tb";
import { Container, Nav, Navbar } from "react-bootstrap";
import { User } from "../models/user";
import NavBarLoggedInView from "./NavBarLoggedInView";
import NavBarLoggedOutView from "./NavBarLoggedOutView";
import styleUtils from "../styles/utils.module.css";
import { Link } from "react-router-dom";

type NavBarProps = {
  loggedInUser: User | null;
  onSignUpClicked: () => void;
  onLoginClicked: () => void;
  onLogoutSuccessful: () => void;
};

const NavBar = ({
  loggedInUser,
  onSignUpClicked,
  onLoginClicked,
  onLogoutSuccessful,
}: NavBarProps) => {
  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="sm"
      sticky="top"
      style={{ height: "4rem" }}
    >
      <Container
        className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}
      >
        <Navbar.Brand
          as={Link}
          to="/"
          className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}
        >
          <TbNotes /> Notes App
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav>
            <Nav.Link as={Link} to="/privacy">
              Privacy
            </Nav.Link>
          </Nav>

          <Nav className="ms-auto" style={{ gap: 10 }}>
            {loggedInUser ? (
              <NavBarLoggedInView
                user={loggedInUser}
                onLogoutSuccessful={onLogoutSuccessful}
              />
            ) : (
              <NavBarLoggedOutView
                onSignUpClicked={onSignUpClicked}
                onLoginClicked={onLoginClicked}
              />
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
